// Merged dashboard block: users, monthly contacts and monthly events shown as
// three labeled-donut sections grouped inside a single card.
import { Box, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import Card from "horizon/components/card/Card";
import UsersSection from "./sections/UsersSection";
import ContactsSection from "./sections/ContactsSection";
import EventsSection from "./sections/EventsSection";

/**
 * Renders the three monthly-overview sections (users, contacts, events) in one
 * card, stacked on small screens and split by dividers from large up.
 * @returns {React.ReactElement}
 */
export default function MonthOverviewCard() {
  const divider = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
  return (
    <Card>
      <SimpleGrid columns={{ base: 1, lg: 3 }} spacing="0" alignItems="stretch">
        <Box h="100%" px={{ lg: "20px" }} pb={{ base: "24px", lg: "0" }}>
          <UsersSection />
        </Box>
        <Box h="100%" px={{ lg: "20px" }} py={{ base: "24px", lg: "0" }} borderColor={divider}
          borderTopWidth={{ base: "1px", lg: "0" }} borderLeftWidth={{ lg: "1px" }}>
          <ContactsSection />
        </Box>
        <Box h="100%" px={{ lg: "20px" }} pt={{ base: "24px", lg: "0" }} borderColor={divider}
          borderTopWidth={{ base: "1px", lg: "0" }} borderLeftWidth={{ lg: "1px" }}>
          <EventsSection />
        </Box>
      </SimpleGrid>
    </Card>
  );
}
